import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface Testimonial {
  id: number;
  content: string;
  author: string;
  role: string;
  company: string;
  avatar: string;
}
interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}
export const TestimonialsSection = ({
  testimonials
}: TestimonialsSectionProps) => {
  return <section className="py-20 bg-[#0F1115]" data-id="element-135">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-138">
            Trusted by industry leaders
          </h2>
          <p className="text-lg text-gray-400" data-id="element-139">
            See what companies and developers are saying about us
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-140">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 relative" data-id="element-141">
              <QuoteIcon className="absolute top-8 right-8 w-8 h-8 text-gray-700 opacity-50" data-id="element-142" />
              <p className="text-gray-300 mb-6 leading-relaxed relative z-10" data-id="element-143">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4" data-id="element-144">
                <img src={testimonial.avatar} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-gray-700" data-id="element-145" />
                <div data-id="element-146">
                  <div className="font-semibold text-white" data-id="element-147">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-148">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};